import React from "react";
import { MessageStatus } from "../../../constant/Types";
import VoicePlayer from "./VoicePlayer";
import { getHoursMinutesTime, trimDoubleQuotes } from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import MessageDateCategories from "./MessageDateCategories";
import { scrollTo } from '../utils/scrollTo'

const VoiceMessageLawyer = ({
  time,
  data,
  status,
  meta,
  messageCancel,
  messageRetry,
  waveSurfer,
  pauseAll,
  messagesList,
  index,
  currentlyItem,
}) => {
  let statusResult =
    status === MessageStatus.sending || status === MessageStatus.failed
      ? status
      : "DONE";

  function cancel() {
    messageCancel(meta);
  }

  function retry() {
    messageRetry(meta.id);
  }

  const { id } = meta

  return (
    <div
      className={`msg msg-voice  ${
        statusResult === "DONE" ? "msg-voice-done" : ""
      }`}
      id={id}
    >
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={messagesList}
        index={index}
        currentlyItem={currentlyItem}
      />
      <div className="msg-wrapper" style={{ float: "left" }}>
        <div className={"msg-avatar-bg"}>
          <div className={"msg-avatar-holder"}>
            <AvatarPreview
              isSvg={false}
              src={currentlyItem.otherProfile || "LAWONE"}
            />{" "}
          </div>
        </div>
        {data.inReplyToTheMessage && <div className="msg-in-reply-text" onClick={() => scrollTo(data.inReplyToTheMessage.id)}>{trimDoubleQuotes(data.inReplyToTheMessage.text || data.inReplyToTheMessage.filename)}</div>}
        <VoicePlayer
          url={data && data.link !== "" ? data.link : ""}
          data={meta && meta.temp ? meta.temp : ""}
          status={status}
          pauseAll={pauseAll}
          key={`voice-${
            meta && meta.id ? meta.id : time
          }-${new Date().getTime()}`}
          keyName={`voice-${
            meta && meta.id ? meta.id : time
          }-${new Date().getTime()}`}
          waveSurfer={waveSurfer}
          id={meta.id}
          cancel={cancel}
          retry={retry}
        />
        <div className={"msg-time"}> {time && getHoursMinutesTime(time)} </div>
      </div>
    </div>
  );
};

export default VoiceMessageLawyer;
